/**
 * Constants and configuration values
 * Per PLAN.md utils/constants.js
 */

// Grid settings
export const GRID_SIZE = 20;        // Grid spacing in pixels
export const GRID_DOT_RADIUS = 1;   // Dot radius

// Zoom constraints per PRD §4.2
export const MIN_ZOOM = 0.25;       // 25%
export const MAX_ZOOM = 4.0;        // 400%
export const ZOOM_STEP = 0.1;       // Zoom increment

// Canvas settings
export const CANVAS_PADDING = 100;  // Padding around content for fit

// Node settings
export const DEFAULT_NODE_WIDTH = 100;
export const DEFAULT_NODE_HEIGHT = 50;
export const NODE_PADDING = 16;     // Padding inside nodes

// Connection settings
export const CONNECTION_HIT_THRESHOLD = 8;  // Pixels for hit detection
export const CONNECTION_HANDLE_SIZE = 12;   // Handle diameter
export const ARROW_SIZE = 10;               // Arrow head size

// Animation durations (ms) per PRD §10.4
export const DURATION_FAST = 100;
export const DURATION_NORMAL = 150;
export const DURATION_SLOW = 200;
export const DURATION_CONNECTION = 250;

// Debounce delays
export const LATEX_DEBOUNCE = 150;  // Live preview debounce per PRD §4.1
export const SAVE_DEBOUNCE = 1000;  // Auto-save debounce

// Keyboard shortcuts per PRD §7.2
export const SHORTCUTS = {
    NEW_NODE: 'n',
    SELECT_TOOL: 'v',
    CONNECT_TOOL: 'c',
    TOGGLE_GRID: 'g',
    GROUP: 'g',           // With meta key
    UNGROUP: 'g',         // With meta + shift
    DUPLICATE: 'd',       // With meta key
    DELETE: 'Backspace',
    UNDO: 'z',            // With meta key
    REDO: 'z',            // With meta + shift
    ZOOM_IN: '=',         // With meta key
    ZOOM_OUT: '-',        // With meta key
    ZOOM_FIT: '0',        // With meta key
    ESCAPE: 'Escape',
    ENTER: 'Enter',
    TAB: 'Tab'
};

// Tool modes
export const TOOL = {
    SELECT: 'select',
    CONNECT: 'connect',
    PAN: 'pan'
};

// Theme values
export const THEME = {
    LIGHT: 'light',
    DARK: 'dark'
};

// localStorage keys
export const STORAGE_KEYS = {
    DOCUMENTS: 'proofroom_documents',
    CURRENT_DOC: 'proofroom_current',
    THEME: 'proofroom_theme'
};
